var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavOrderHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.334 7.5V5a3.333 3.333 0 00-6.667 0v2.5M2.994 8.627l-.5 5.333c-.142 1.517-.214 2.275.038 2.86a2.5 2.5 0 001.1 1.209c.56.305 1.321.305 2.844.305h7.048c1.524 0 2.285 0 2.845-.305a2.5 2.5 0 001.1-1.208c.251-.586.18-1.344.038-2.86l-.5-5.334c-.12-1.28-.18-1.92-.468-2.405a2.5 2.5 0 00-1.077-.98C14.954 5 14.312 5 13.024 5H6.976c-1.286 0-1.929 0-2.438.242a2.5 2.5 0 00-1.076.98c-.288.484-.348 1.124-.468 2.405z"
  })));
}
export default SvgNavOrderHistory;